import Api from './Api';

class HelloWorldApi extends Api {
    getExample() {
        return this._get("/example");
    }

    postExample() {
        return this._post("/other-example", {
            "hello": "world",
        });
    }
}

export default HelloWorldApi;